export const SALES_PHONE = '+919921318237';
export const SALES_PHONE_DISPLAY = '+91 9921318237';

export const LANDING_SECTION_IDS = {
  product: 'product',
  howItWorks: 'how-it-works',
  useCases: 'use-cases',
  trust: 'trust',
  faq: 'faq',
  contact: 'contact',
} as const;

export function scrollToSection(id: string) {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
}
